import React, { Component } from "react";
import { getAccessToken, getTenantId } from "egov-ui-kit/utils/localStorageUtils";
import { StayCurrentPortraitSharp } from "@material-ui/icons";

class EGFFinance extends Component {
  constructor(props) {
    super(props);
    this.onFrameLoad = this.onFrameLoad.bind(this);
    this.resetIframe = this.resetIframe.bind(this);
  }


  onFrameLoad() {
    document.getElementById("erp_iframe").style.display = "block";
  }

  render() {
    let auth_token = getAccessToken(),
      locale = localStorage.getItem("locale"),
      // locale = "en_IN",
      menuUrl = this.props.location.pathname,
      loc = window.location,
      subdomainurl,
      domainurl,
      finEnv,
      hostname = loc.hostname,
      winheight = window.innerHeight - 100,
      erp_url,
      tenantId = getTenantId();
      // tenantId = "hp";
    //Reading domain name from the request url
    domainurl = hostname.substring(hostname.indexOf(".") + 1);
    // Reading environment name (ex: dev, qa, uat, fin-uat etc) from the globalconfigs if exists else reading from the .env file
    finEnv = this.globalConfigExists() ? window.globalConfigs.getConfig("FIN_ENV") : process.env.REACT_APP_FIN_ENV;
    // Preparing finance subdomain url using the above environment name and the domain url
    subdomainurl = !!(finEnv) ? "-" + finEnv + "." + domainurl : "." + domainurl;
    // erp_url = loc.protocol + "//" + getTenantId().split(".")[1] + subdomainurl + menuUrl;
    const currentPath = window.location.origin;
    // const  hostName  = window.location;
    console.log("currentPathorigin",currentPath)
    // console.log("currentPathhost",hostName)
    let subdomainUrlNew;
    if (currentPath.includes("abmapplication.com") || currentPath.includes("abmindia.com")) {
  subdomainUrlNew = currentPath;
} 
else if (currentPath.includes("localhost")) {
  subdomainUrlNew = "http://150.241.245.142:9080"; // for localhost
} 
else {
  // subdomainUrlNew = `http://${hostName}:9080`;
  subdomainUrlNew = `http://${currentPath.split(":")[1].replaceAll("//","")}:9080`;
}
    erp_url = subdomainUrlNew + menuUrl;
    console.log("erp_url22", erp_url, auth_token, tenantId, locale);

    return (
      <div>
        <iframe name="erp_iframe" id="erp_iframe"
          // height={winheight} 
          width="100%" className="main-iframe-wrapper"
          style={{ height: 'calc(100vh - 100px)' }}
        />
        <form action={erp_url} id="erp_form" method="post" target="erp_iframe">
          <input readOnly hidden="true" name="auth_token" value={auth_token} />
          <input readOnly hidden="true" name="tenantId" value={tenantId} />
          <input readOnly hidden="true" name="locale" value={locale} />
          <input readOnly hidden="true" name="formPage" value="true" />
        </form>
      </div>
    );
  }
  componentDidMount() {
    console.log("erp_url13");
    window.addEventListener("message", this.onMessage, false);
    window.addEventListener("loacaleChangeEvent", this.resetIframe, false);
    document.getElementById("erp_iframe").addEventListener("load", this.onFrameLoad);
  }
  componentDidUpdate() {
    let isSecure = window.location.protocol === "https";
    let localeCookie = "locale=" + localStorage.getItem("locale") + ";path=/;domain=." + this.getSubdomain();
    if (isSecure) {
      localeCookie += ";secure";
    }
    window.document.cookie = localeCookie;
    document.forms["erp_form"].submit();
  }
  onMessage = (event) => {
    if (event.data != "close") return;
    // document.getElementById('erp_iframe').style.display='none';
    this.props.history.push("/inbox");
  };
  resetIframe() {
    this.forceUpdate();
  }
  getSubdomain() {
    let hostname = window.location.hostname;
    return hostname.substring(hostname.indexOf(".") + 1);
  }
  globalConfigExists() {
    return typeof window.globalConfigs !== "undefined" && typeof window.globalConfigs.getConfig === "function";
  }
}

export default EGFFinance;



// WEBPACK FOOTER //
// src/modules/employee/Erp/EGF/index.js